import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./itemsBills.css";
import { deleteItemBill, getAllItemsBill } from "../../../redux/apiCalls/itemsCall/itemBills";
import Swal from "sweetalert2";
import { Toast } from "../../../helpers/alert";
import { Pencil, Trash2 } from "lucide-react";

const ItemsBill = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector((state) => state.itemsBill.itemsBill);
  const query = new URLSearchParams(useLocation().search);
  const initialSupplier = query.get("supplier") || "";
  const suppliers = useSelector((state) => state.supplier.supplier);
  const user = useSelector((state) => state.user.currentUser);
  const [supplier, setSupplier] = useState(initialSupplier);
  const searchParams = new URLSearchParams(window.location.search);
  const itemsBillId = searchParams.get("itemsBillId");

  useEffect(() => {
    if (user.privilege === "editor" || user.privilege === "master") {
      getAllItemsBill(dispatch, user?.accessToken, supplier);
    }
  }, [supplier, user, dispatch]);

  const sortedSuppliers = useMemo(() => {
    if (!suppliers) return [];
    return [...suppliers].sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [suppliers]);

  // Filtrado por proveedor (cuando hay uno seleccionado)
  const filteredItems = useMemo(() => {
    const list = Array.isArray(items) ? items : [];
    if (!supplier) return list;
    return list.filter(
      (it) =>
        (it?.proveedor || "").toString().toLowerCase() ===
        supplier.toLowerCase()
    );
  }, [items, supplier]);

  // Sincronizamos con query param ?supplier=
  useEffect(() => {
    setSupplier(initialSupplier);
  }, [initialSupplier]);

  useEffect(() => {
    if (itemsBillId) {
      const el = document.getElementById(`itb-${itemsBillId}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [itemsBillId]);

async function handleDelete(itemId) {
    Swal.fire({
      title: `¿Está seguro de que desea eliminar el concepto?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar el concepto.",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteItemBill(dispatch, itemId, user.accessToken);
           getAllItemsBill(dispatch, user?.accessToken, supplier);
          Toast.fire({
            icon: "success",
            title: "Concepto eliminado correctamente.",
          });
        } catch (error) {
          Toast.fire({
            icon: "error",
            title: "No se pudo eliminar el concepto.",
          });
        }
      }
    });
  }

  return (
    <div className="itemsBill-view">
      <div className="ebm__table ebm__table-head ebm__table-head--below">
        <div className="ebm__th">CONCEPTO</div>
        <div className="ebm__th">CLASE</div>
        <div className="ebm__th">UNIDAD DE CONSUMO</div>
        <div className="ebm__th">UNIDAD DE COSTO</div>
        <div className="ebm__th">
          <select
            className="ebm__select"
            value={supplier}
            onChange={(e) => setSupplier(e.target.value)}
            title="Filtrar por proveedor"
          >
            <option value={""}>PROVEEDORES</option>
            {sortedSuppliers.map((s) => (
              <option key={s.id} value={s.nombre.toLowerCase()}>
                {s.nombre}
              </option>
            ))}
          </select>
        </div>
        <div className="ebm__th ebm__th--actions">ACCIONES</div>
      </div>

      {filteredItems.map((it) => (
        <div key={it.id} id={`itb-${it.id}`} className="ebm__row">
          <div className="ebm__td">{it?.lineItemText || "-"}</div>
          <div className="ebm__td">{it?.class || "-"}</div>
          <div className="ebm__td">{it?.consumptionUnit || "-"}</div>
          <div className="ebm__td">{it?.costUnit || "-"}</div>
          <div className="ebm__td">{it?.proveedor || "-"}</div>

          <div className="ebm__td ebm__td--actions">
            {user?.privilege === "master" && (
              <div>
                <button
                  className="ebm__btn ebm__btn--secondary"
                  onClick={() => navigate(`/itemBill/edit/${it.id}`)}
                  title="Editar"
                >
                  <Pencil size={16} />
                  <span>Editar</span>
                </button>
                <button
                  className="ebm__btn ebm__btn--danger"
                  title="Eliminar"
                  onClick={() => handleDelete(it.id)} 
                >
                  <Trash2 size={16} />
                  <span>Eliminar</span>
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ItemsBill;
